import "./FeedCardHashtag.css";

export default function FeedCardHashtag(props) {
    return (
        <p className="FeedCardHashtag">#{props.text}</p>
    )
}